import * as React from 'react'
import MuiDivider from '@mui/material/Divider'
import Grid, { GridBaseProps } from '@mui/material/Grid2'

const Divider: React.FC<GridBaseProps> = ({ size }) => {
  return (
    <Grid size={size}>
      <MuiDivider
        flexItem
        style={{
          marginTop: '1em',
          marginBottom: '1em',
          borderColor: '#55B3D7',
        }}
      />
    </Grid>
  )
}

export default Divider
